const RegistrationOption = Object.freeze({
    NONE: 'NONE',
    FORCED: 'FORCED',
    OPTIONAL: 'OPTIONAL',
    FORCED_DISPLAYED: 'FORCED_DISPLAYED',
    OPTIONAL_PRESELECTED: 'OPTIONAL_PRESELECTED',
});

module.exports = { RegistrationOption };
